module.exports = "/_next/static/images/sai-b65ab4f4eefda6f388ba0167a5d5a7fa.png";